var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer250DpEff5F2Fill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#EFF5F2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.77-181.54v-30.77h818.46v30.77H70.77Zm104.61-80q-23.05 0-39.22-16.16Q120-293.87 120-316.92v-409.23q0-23.06 16.16-39.23 16.17-16.16 39.22-16.16h609.24q23.05 0 39.22 16.16Q840-749.21 840-726.15v409.23q0 23.05-16.16 39.22-16.17 16.16-39.22 16.16H175.38Zm0-30.77h609.24q9.23 0 16.92-7.69 7.69-7.69 7.69-16.92v-409.23q0-9.23-7.69-16.93-7.69-7.69-16.92-7.69H175.38q-9.23 0-16.92 7.69-7.69 7.7-7.69 16.93v409.23q0 9.23 7.69 16.92 7.69 7.69 16.92 7.69Zm-24.61 0V-750.77-292.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer250DpEff5F2Fill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/computer_250dp_EFF5F2_FILL0_wght200_GRAD0_opsz48.3eb43971b08c95258fa4976f80d82673.svg";
export { ForwardRef as ReactComponent };